'use strict';

// ----------------------------------------
// Private
// ----------------------------------------

let url = window.B2FAPI.ajax.printouts;
let $loadBtn = $('#show-more-printouts');
let $preloader = $('.preloader');
let $container = $('.printouts__items-block');
let $filtersContainer = $('.partners-block');
let page;
let productId;

// ----------------------------------------
// Public
// ----------------------------------------

function loadItems () {
	$loadBtn.on('click', function () {
		page = $(this).data('page');
		productId = $(this).data('product-id');
		$(this).data('page', (page + 1));

		$.ajax({
			type: 'post',
			dataType: 'JSON',
			url: url,
			data: {
				page: page,
				productId: productId
			},

			beforeSend: function () {
				$preloader.fadeIn();
			},

			success: function (data) {
				page = data.page;

				$container.append(data.html);

				if (data.last) {
					$loadBtn.remove();
				}
			},
			complete: function () {
				$preloader.delay(300).fadeOut('fast');
			}
		});
	});
}

function loadFilterItems (html) {
	$preloader.fadeIn();

	$filtersContainer.html(html);

	$preloader.delay(300).fadeOut('fast');
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {loadItems, loadFilterItems};



// WEBPACK FOOTER //
// ./src/js/_modules/load-items.js